import { createElementBlock as l, openBlock as s, createElementVNode as e } from "vue";
const o = {
  width: "83",
  height: "82",
  viewBox: "0 0 83 82",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__call-to-action-mail"
};
function r(n, t) {
  return s(), l("svg", o, t[0] || (t[0] = [
    e("path", {
      d: "M41.5 1L69.7843 12.7157L81.5 41L69.7843 69.2843L41.5 81L13.2158 69.2843L1.5 41L13.2158 12.7157L41.5 1Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    e("path", {
      d: "M41.5001 7L65.5418 16.9584L75.5002 41.0001M41.5001 75.0002L17.4584 65.0418L7.5 41.0001",
      stroke: "#00E0E0",
      "stroke-width": "2",
      class: "svg__stroke--help-green-03"
    }, null, -1),
    e("path", {
      d: "M25.875 30.556V51.5641C25.875 51.9157 26.16 52.2007 26.5116 52.2007H56.4884C56.84 52.2007 57.125 51.9157 57.125 51.5641V30.556C57.125 30.2045 56.84 29.9194 56.4884 29.9194H26.5116C26.16 29.9194 25.875 30.2045 25.875 30.556Z",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1),
    e("path", {
      d: "M42.3315 44.1294L42.8214 44.6973L42.3315 44.1294ZM40.6682 44.1293L40.1782 44.6971L40.6682 44.1293ZM56.591 30.8395L41.8417 43.5615L42.8214 44.6973L57.5707 31.9754L56.591 30.8395ZM41.1581 43.5614L26.4138 30.8396L25.4339 31.9753L40.1782 44.6971L41.1581 43.5614ZM41.8417 43.5615C41.6453 43.7309 41.3545 43.7309 41.1581 43.5614L40.1782 44.6971C40.9375 45.3522 42.062 45.3523 42.8214 44.6973L41.8417 43.5615Z",
      fill: "#0AA5FF",
      class: "svg__fille--default-cyan-03"
    }, null, -1)
  ]));
}
const a = { render: r };
export {
  a as default,
  r as render
};
